var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Trainer as TrainerModel } from '@/models/Trainer';
import PageHeader from '@/components/page-header/PageHeader';
import { fileToBase64, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Token } from '@/support/Token';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Trainer = class Trainer extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Trainer';
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.trainer = new TrainerModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [{ name: this.$tc('roles.user', 2) }, { name: this.$tc('roles.trainer', 2), path: '/trainers' }, { name: this.trainer.name || '', path: this.$route.path }];
    }
    mounted() {
        new TrainerModel()
            .include('token')
            .find(this.$route.params.id)
            .then((trainer) => {
            this.trainer = trainer;
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.trainer.password = this.password.new;
        }
        const payload = this.trainer.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.trainer
            .include(['trainer', 'roles'])
            .update(payload)
            .then((trainer) => {
            this.resetPassword();
            this.trainer = trainer;
            this.updateCurrentUser(trainer);
        });
    }
    resetPassword() {
        delete this.trainer.password;
        delete this.trainer.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(trainer) {
        if (trainer.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', trainer);
        }
    }
    setToken() {
        Token.set(this.trainer.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const trainerWithDataObjects = await new TrainerModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (trainerWithDataObjects) {
            this.baseImage = trainerWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
        // if (!this.trainer.avatar) {
        //   return;
        // }
        // const canvas = document.createElement('canvas');
        // const img = new Image();
        // const context = canvas.getContext('2d');
        // img.crossOrigin = 'Anonymous';
        // img.src = this.trainer.avatar;
        // if (!img) {
        //   return;
        // }
        // if (!context) {
        //   return;
        // }
        // img.onload = () => {
        //   canvas.width = img.width;
        //   canvas.height = img.height;
        //   context.drawImage(img, 0, 0, img.width, img.height);
        //   this.baseImage = canvas.toDataURL();
        //   this.isChangingAvatar = true;
        // };
    }
    avatarChanged(imageUrl) {
        this.trainer
            .include(['trainer', 'roles'])
            .update({ avatar: imageUrl })
            .then((trainer) => {
            this.trainer.avatar = imageUrl;
            this.updateCurrentUser(trainer);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.trainer.has_mfa_token;
    }
    async removeMfa() {
        if (this.trainer) {
            const trainer = await this.trainer
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (trainer) {
                this.$set(this.trainer, 'has_mfa_token', false);
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Trainer = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Trainer);
export default Trainer;
